<template>
  <div class="login-page page-padding-top">
    <div class="login-top flex-center-between" v-if="!hideTopBar">
      <div class="back">
        <Icon name="arrow-left" @click="back" size="20" color="#353945"></Icon>
      </div>
      <span class="page-title">{{(step == 2 && captchaEnabled) ? $t('register.title2') : (step == 3 ? $t('register.title3') : '')}}</span>
      <span class="right"></span>
    </div>

    <div class="logo" v-show="step == 1">
      <img :src="logoUrl" alt="">
    </div>
    <div class="modal-title" v-show="step == 1">{{i18n.t('register.title')}}</div>

    <div class="tabs" v-show="step == 1">
      <div class="tab" :class="tabIndex == 1 ? 'active' : ''" @click="changeTab(1)">{{i18n.t('register.tab')}}</div>
      <div class="tab" :class="tabIndex == 2 ? 'active' : ''" @click="changeTab(2)">{{i18n.t('register.tab2')}}</div>
    </div>

    <div class="page-desc" v-show="step == 2 && captchaEnabled">{{$t('register.label4')}} {{tabIndex == 1 ? form.username : form.phone}} {{$t('register.label5')}}</div>

    <div class="login-form">
      <div class="form-label" v-if="tabIndex == 1 && step == 1">{{$t('register.label2')}}</div>
      <div class="form-item  flex-center" v-show="tabIndex == 1 && step == 1" >
        <div class="input">
          <input type="text" v-model="form.username"   :placeholder="i18n.t('register.labelPlaceholder1')">
        </div>
      </div>

      <div class="form-label" v-if="tabIndex == 2 && step == 1">{{$t('register.label3')}}</div>
      <div class="form-item  flex-center" :class="inputActive ? 'active' : ''" v-if="tabIndex == 2 && step == 1">
        <div class="pre flex-center-start" @click="changePre">
          {{phonePre}}
          &nbsp;&nbsp;
          <icon name="arrow-down" size="14" color="#353945"></icon>
        </div>
        <div class="flex-1">
          <div class="input clear">
            <input type="tel" @focus="inputActive = true" @blur="inputActive = false" v-model="form.phone" :placeholder="i18n.t('register.labelPlaceholder8')">
          </div>
        </div>
      </div>

      <div class="form-label" v-show="step == 1 && showInvite">
        {{i18n.t('register.label')}}
      </div>

      <div class="form-item clear flex-center" v-show="step == 1 && showInvite" >
        <div class="input">
          <input type="tel"  v-model="form.inviteCode"  :placeholder="i18n.t('register.labelPlaceholder5')">
        </div>
      </div>

      <div class="form-label" v-if="step == 4">{{$t('register.label2')}}</div>
      <div class="form-item  flex-center" v-show="step == 4" >
        <div class="input">
          <input type="text" v-model="form.username"   :placeholder="i18n.t('register.labelPlaceholder1')">
        </div>
      </div>

      <div class="form-label" v-show="step == 2 && captchaEnabled" >
        {{$t(`register.label6_${tabIndex}`)}}
      </div>

      <div class="form-item clear flex-center" v-show="step == 2 && captchaEnabled" >
        <div class="input long">
          <input type="tel"  v-model="form.code"  :placeholder="i18n.t('register.labelPlaceholder2')">
        </div>
        <div class="adot long">
          <span class="gray" v-if="isDisabled">{{$t('register.send')}}({{timeCount}})</span>
          <span v-else @click="resend">{{$t('register.btn1')}}</span>
        </div>
      </div>

      <div class="form-label flex-center-between" v-show="step == 3 " >
        <div >{{$t(`register.label7`)}}</div>
        <div class="flex-center auth-line" v-show="form.password">
          <span :class="lineIndex == 1 ? 'red' : (lineIndex == 2 ? 'yellow' : (lineIndex == 3 ? 'green' : ''))">{{$t(`register.label${lineIndex < 2 ? 9 : (lineIndex == 2 ? 10 : 11)}`)}}</span>
          <div class="line" v-for="i in 3" :key="i" :class="lineIndex >= i && (lineIndex == 1 ? 'red' : (lineIndex == 2 ? 'yellow' : (lineIndex == 3 ? 'green' : '')))" ></div>
        </div>
      </div>

      <div class="form-item flex-center" v-show="step == 3" >
        <div class="input">
          <input :type="showPassword ? 'text' : 'password'" @input="changePassword" v-model="form.password" :placeholder="i18n.t('register.labelPlaceholder3')">
        </div>
        <div class="adot" @click="changeShowPassword">
          <img :src="showPassword ? eyeUrl2 : eyeUrl" alt="" >
        </div>
      </div>

      <div class="password-auth" v-show="showPasswordAuth && step == 3">
        <div class="auth-line flex-center-start" :class="passwordAuthList.indexOf(0) > -1 ? 'green' : ''">
          <img :src="passwordAuthList.indexOf(0) > -1 ? checkUrl2 : checkUrl" alt="">
          <span>{{i18n.t('register.passwordMinLength')}}</span>
        </div>
      </div>

      <div class="form-label " v-show="step == 3" >
        {{$t('register.label8')}}
      </div>

      <div class="form-item flex-center" v-show="step == 3" >
        <div class="input">
          <input :type="showSafePassword ? 'text' : 'password'" @input="changeConfirmPassword" v-model="form.confirmPassword" :placeholder="i18n.t('register.labelPlaceholder4')"/>
        </div>
        <div class="adot"  @click="changeShowSafePassword">
          <img :src="showSafePassword ? eyeUrl2 : eyeUrl" alt="">
        </div>
      </div>


    </div>



    <Button class="login-btn register-submit-btn" @click="submit" :class="btnShow ? '' : 'disabled'">
      <template v-if="step == 1 && !captchaEnabled">
        {{$t('register.btn3')}}
      </template>
      <template v-else>
        {{i18n.t(`register.btn${parseInt(step)}`)}}
      </template>
    </Button>

    <div class="bottom-line flex-center " v-show="step == 1">
      <span class="blue" @click="toLogin">{{$t('register.login')}}</span>
    </div>

    <div class="role " v-show="step == 1" @click="changeRole">
      <span>{{i18n.t('register.role5')}}</span>
      <span class="high" @click.stop="showRole(0)">{{i18n.t('register.role6')}}</span>
      <span>{{i18n.t('register.role7')}}</span>
      <span class="high" @click.stop="showRole(1)">{{i18n.t('register.role8')}}</span>
    </div>


    <Popup v-model:show="showPopup" position="bottom">
			<div class="country-list" >
				<div class="title flex-center-between">
          <icon name="arrow-left" size="20" color="#000" @click="cancel"></icon>
          <span>{{i18n.t('login.labelPlaceholder3')}}</span>
          <span></span>
        </div>
        <div class="search-list flex-center-between">
          <div class="flex-center">
            <img :src="searchUrl" alt="">
            <input type="text" v-model="keyword" :placeholder="i18n.t('register.labelPlaceholder7')" @input="searchCountry" @change="searchCountry">
          </div>
        </div>
        <div class="group-list login" v-for="(item, i) in countryList" :key="i">
          <div class="country-title" :id="item.id" v-if="item.id != 'common' && !keyword">{{item.title}}</div>
          <div class="country-title flex-center-start" v-if="item.id == 'common' && !keyword">
            <img :src="starUrl" alt="">
            {{$t('common.use')}}
          </div>
          <div class="list flex-center-start" :class="child.key == phonePre ? 'active' : ''" v-for="(child, index) in item.children" :key="index" @click.stop="chooseCountry(child)">
            <div class="img-box flex-center">
              <img :src="child.icon" alt="">
              <span>{{getCountryName(child.title)}}</span>
            </div>
            <div>
              {{child.key}}
            </div>
          </div>
        </div>
        <div class="fast-link">
          <div class="link" v-for="(item, i) in linkList" :key="i" @click="toFastPage(item)">
            {{item.title}}
          </div>
        </div>
			</div>
    </Popup>
  </div>
</template>
<script>
  import { Button, Popup, Icon } from 'vant'
  import { register, sendCode, checkEmailCode, sendSms, checkPhoneCode, userArticle } from '@/api/login'
  import { setToken, setUser, setUserId } from '@/utils/auth'
  import { isCaptchaEnabled } from '@/utils/captcha'
  import { normalizePassword, isPasswordLongEnough, validatePasswordPair } from '@/utils/passwordRules'
  export default {
    components: {
      Button,
      Popup,
      Icon,
    },
    data() {
      return {
        step: 1,
        lineIndex: 0,
        form: {
          username: '',
          phone: '',
          password: '',
          confirmPassword: '',
          code: '',
          inviteCode: ''
        },
        inputActive: false,
        logoUrl: require('../../assets/imgs/logo6.png'),
        starUrl: require('../../assets/imgs/icon-star.png'),
        backUrl: require('../../assets/imgs/icon-back.png'),
        closeUrl: require('../../assets/imgs/icon-close.png'),
        emailUrl: require('../../assets/imgs/icon-email2.png'),
        passwordUrl: require('../../assets/imgs/icon-password.png'),
        eyeUrl: require('../../assets/imgs/icon-eye.png'),
        eyeUrl2: require('../../assets/imgs/icon-eye2.png'),
        userUrl: require('../../assets/imgs/icon-users.png'),
        downUrl: require('../../assets/imgs/icon-arrow-down3.png'),
        checkedUrl: require('../../assets/imgs/icon-checked.png'),
        checkedUrl2: require('../../assets/imgs/icon-uncheck.png'),
        checkUrl: require('../../assets/imgs/icon-check.png'),
        checkUrl2: require('../../assets/imgs/icon-check2.png'),
        phoneUrl: require('../../assets/imgs/icon-phone2.png'),
        searchUrl: require('../../assets/imgs/icon-search.png'),
        showPassword: false,
        showSafePassword: false,
        activeIndex: 1,
        isDisabled: false,
        sendTime: '',
        checkRole: false,
        // 隐藏邀请码输入框（仍支持通过 URL ?code= 传入并提交）
        showInvite: false,
        showPasswordAuth: false,
        passwordAuthList: [],
        phonePre: '+1',
        tabIndex: 1,
        showPopup: false,
        showRoleModal: false,
        countryList: [],
        keyword: '',
        serviceData: {},
        privacyData: {},
        roleData: {},
        linkList: []
      }
    },
    computed: {
      timeCount() {
        return this.sendTime + 's'
      },
      countryListBak() {
        return this.$store.state.countryList
      },
      captchaEnabled() {
        return isCaptchaEnabled(this.$store.state.captchaEnable)
      },
      btnShow() {
        if (this.step == 1) {
          return (this.tabIndex == 1 && this.form.username) || (this.tabIndex == 2 && this.form.phone)
        } else if (this.step == 4) {
          return this.form.username
        } else if (this.step == 2) {
          // 如果验证码关闭,步骤2不需要验证码
          return !this.captchaEnabled || this.form.code
        } else if (this.step == 3) {
          return isPasswordLongEnough(this.form.password) && !!normalizePassword(this.form.confirmPassword)
        }
      }
    },
    mounted() {
      let code = this.$route.query.code
      if (code) {
        this.form.inviteCode = code
      }
      this.countryList = [].concat(this.countryListBak)
      this.initArticle()
         this.linkList = this.countryList.filter(v => {
        return v.id != 'common'
      })
    },
    methods: {
      initArticle() {
        let form = new FormData()
        let form2 = new FormData()
        form.append('Type', 0)
        form2.append('Type', 1)
        //服务条款
        userArticle(form).then(res => {
          let data = res.data.Items
          if (data && data.length > 0) {
            this.serviceData = data[0]
          }
        })
        //隐私策略
        userArticle(form2).then(res => {
          let data = res.data.Items
          if (data && data.length > 0) {
            this.privacyData = data[0]
          }
        })
      },
      changeTab(index) {
        if (this.step == 1) {
          this.tabIndex = index
        }
      },
      back() {
        this.$router.go(-1)
      },
      toLogin() {
        this.$router.push({
          name: 'login'
        })
      },
      toSet() {
        if (!this.form.code ) {
          this.$toast.fail(this.i18n.t('register.labelPlaceholder2'))
          return
        }
        let form = new FormData()
        form.append('Code', this.form.code)
        form.append('Type', 1)
        if (this.tabIndex == 1) {
          form.append('Email', this.form.username)
          checkEmailCode(form).then(res => {
            if (res.code == 0) {
              this.step = 3
            } else {
              this.$toast.fail(res.msg)
            }
          })
        } else {
          form.append('Phone', this.phonePre + this.form.phone)
          checkPhoneCode(form).then(res => {
            if (res.code == 0) {
              this.step = 3
            } else {
              this.$toast.fail(res.msg)
            }
          })
        }
      },
      submit() {
        if (!this.btnShow) {
          return
        }
        if (this.step == 1) {
          // 如果验证码关闭,直接跳到步骤3
          if (!this.captchaEnabled) {
            this.step = 3
          } else {
            if (this.tabIndex == 1) {
              this.sendEmail()
            } else {
              this.sendPhoneSms()
            }
          }
        }else if (this.step == 2) {
          this.toSet()
        } else {
          // 不管是手机注册还是邮箱注册，步骤3之后都直接提交
          this.doSubmit()
        }
      },
      doSubmit() {
        const validation = validatePasswordPair(this.form.password, this.form.confirmPassword)
        this.form.password = validation.password
        this.form.confirmPassword = validation.confirmPassword

        if (!validation.password) {
          this.$toast.fail(this.i18n.t('register.labelPlaceholder3'))
          return
        }
        if (validation.isTooShort) {
          this.$toast.fail(this.i18n.t('register.passwordMinLength'))
          return
        }
        if (!validation.confirmPassword) {
          this.$toast.fail(this.i18n.t('register.labelPlaceholder4'))
          return
        }
        if (validation.isMismatch) {
          this.$toast.fail(this.i18n.t('register.passwordDiff'))
          return
        }

        let form = new FormData()
        // 移动端: tabIndex == 1 是邮箱注册, tabIndex == 2 是手机注册
        if (this.tabIndex == 1) {
          form.append('Email', this.form.username)
        } else {
          form.append('Email', '') // 手机注册时Email为空
        }
        if (this.tabIndex == 2) {
          form.append('Phone', this.phonePre + this.form.phone)
          form.append('CountryCode', this.phonePre)
        }
        form.append('Password', validation.password)
        // form.append('SafePassword', this.form.safePassword) // Removed
        form.append('InviteCode', this.form.inviteCode)
        form.append('Code', this.form.code)
        register(form).then(res => {
          if (res.code == 0) {
            this.$toast.success(this.i18n.t('register.success'))
            // 延迟跳转，确保提示显示
            setTimeout(() => {
              this.$router.push({
                name: 'login'
              })
            }, 1500)
          } else {
            this.$toast.fail(res.msg)
          }
        })
      },
      sendPhoneSms(){
        if (!this.form.phone) {
          this.$toast.fail(this.i18n.t('register.labelPlaceholder8'))
          return
        }
        // if (!this.form.inviteCode) {
        //   this.$toast.fail(this.i18n.t('register.labelPlaceholder5')
        //   return
        // }
        let form = new FormData()
        form.append('Phone', this.phonePre + this.form.phone)
        form.append('Invite', this.form.inviteCode)
        form.append('Type', 1)
        sendSms(form).then(res => {

          if (res.code == 0) {
            this.step = 2
            this.countDown(60)
          } else {
            this.$toast.fail(res.msg)
          }
        })
      },
      sendEmail(){
        if (!this.form.username) {
          this.$toast.fail(this.i18n.t('register.labelPlaceholder1'))
          return
        }
        // if (!this.form.inviteCode) {
        //   this.$toast.fail(this.i18n.t('register.labelPlaceholder5'))
        //   return
        // }
        let form = new FormData()
        form.append('Email', this.form.username)
        form.append('Invite', this.form.inviteCode)
        form.append('Type', 1)
        sendCode(form).then(res => {
          if (res.code == 0) {
            this.step = 2
            this.countDown(60)
          } else {
            this.$toast.fail(res.msg)
          }
        })
      },
      countDown(time) {
        if (time > 0) {
          this.isDisabled = true
          time -= 1
          this.sendTime = time
          setTimeout(() => {
            this.countDown(time)
          }, 1000)
        } else {
          this.sendTime = ''
          this.isDisabled = false
        }
      },
      cancel() {
        this.showPopup = false
        this.showRoleModal = false
      },
      checkCodeSize() {
        let code = this.form.code + ''
        if (code.length > 6) {
          code = code.substring(0, 6)
          this.form.code = parseInt(code)
        }
      },
      getCodeActive(i) {
        let code = this.form.code + ''
        if (!code) {
          return i == this.activeIndex ? 'active' : ''
        }
        return i == code.length + 1 ? 'active' : ''
      },
      inputCode() {
        this.activeIndex = 1
        this.$refs.codeInput.focus()
      },
      getCodeStr(i) {
        let code = this.form.code + ''
        if (!code) {
          return ''
        }
        let str = code.substring(i - 1, i)
        return str
      },
      resend() {
        if (!this.captchaEnabled || this.isDisabled) {
          return
        } else {
          if (this.tabIndex == 1) {
            this.sendEmail()
          } else {
            this.sendPhoneSms()
          }
        }
      },
      changeRole() {
        this.checkRole = !this.checkRole
      },
      changeShowPassword() {
        this.showPassword = !this.showPassword
      },
      changeShowSafePassword() {
        this.showSafePassword = !this.showSafePassword
      },
      changeShowInvite() {
        this.showInvite = !this.showInvite
      },
      changePassword() {
        if (this.step == 1) {
          return
        }
        this.form.password = normalizePassword(this.form.password)
        this.showPasswordAuth = !!this.form.password
        let result = []

        if (isPasswordLongEnough(this.form.password)) {
          result.push(0)
          this.lineIndex = 3
        } else {
          this.lineIndex = 0
        }

        this.passwordAuthList = result
      },
      changeConfirmPassword() {
        this.form.confirmPassword = normalizePassword(this.form.confirmPassword)
      },
      changePre() {
        this.showPopup = true
      },
      chooseCountry(data) {
        this.phonePre = data.key
        this.showPopup = false
      },
      getCountryName(name) {
        if (!name) {
          return ''
        }
        let newName = ''
        newName = name.substring(0, name.indexOf('(') - 1)
        return newName
      },
      searchCountry() {
        if (this.keyword) {
          this.countryList = this.countryListBak.map(v => {
            let children = v.children.filter(val => {
              return val.title.toLowerCase().indexOf(this.keyword.toLowerCase()) > -1  && v.id != 'common'
            })
            if (children.length > 0) {
              return {
                children: children
              }
            } else {
              return {
                children: []
              }
            }
          })
        } else {
          this.countryList = [].concat(this.countryListBak)
        }
      },
      showRole(type) {
        if (type == 1) {
          this.$router.push({
            name: 'privacy'
          })
        } else {
          this.$router.push({
            name: 'agreement'
          })
        }
      },
      toFastPage(key) {
        let dom = document.getElementById(key.id)
        let parentDom = document.querySelector('.country-list')
        if (dom && parentDom) {
          let domTop = dom.offsetTop
          parentDom.scrollTo({
            top: domTop - 124
          })
        }
      }
    },
  }
</script>
